import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextLink from 'components/Luxkit/TextLink'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import { replace } from 'connected-react-router'
import { queryKeyFilters } from 'constants/url'
import useOfferList from 'hooks/Offers/useOfferList'
import { useAppDispatch } from 'hooks/reduxHooks'
import { deleteSearchParams } from 'lib/url/searchUrlUtils'
import React, { useCallback, useMemo } from 'react'
import { connect } from 'react-redux'

interface Props {
  location: string;
  filters: App.OfferListFilters;
}

interface MappedStateProps {
  windowSearch: string;
}

function HotelSearchDestinationNoResults(props: Props & MappedStateProps) {
  const { location, filters, windowSearch } = props
  const expandedFilters = useMemo((): App.OfferListFilters => ({
    ...filters,
    distanceGt: 0,
    distanceEq: undefined,
  }), [filters])

  const bedbankFilters = useMemo((): App.OfferListFilters => ({
    ...expandedFilters,
    offerTypes: ['bedbank_hotel'],
  }), [expandedFilters])
  const dispatch = useAppDispatch()

  const filterCount = (filters.holidayTypes?.length ?? 0) + (filters.amenities?.length ?? 0) + (filters.inclusions?.length ?? 0) + (filters?.priceLte ? 1 : 0) + (filters.locations?.length ?? 0) + (filters.customerRatingGte ? 1 : 0)
  const hasFiltersApplied = filterCount > 0

  const onResetAllClick = useCallback(() => {
    const newSearch = deleteSearchParams(windowSearch, ...queryKeyFilters)
    dispatch(replace({ search: newSearch }))
  }, [dispatch, windowSearch])

  const [offerList] = useOfferList(expandedFilters)
  const [bedbankOfferList] = useOfferList(bedbankFilters)

  const hasNearby = offerList.offerIds.length > 0 || bedbankOfferList.offerIds.length > 0

  return <VerticalSpacer gap={8}>
    <Heading variant="heading3">
      Sorry, we couldn't find any offers in {location}
    </Heading>
    <BodyText variant="medium">
      {hasFiltersApplied ? 'Try a different search or explore our top offers' : 'Try a different location or explore our top offers'}
      {hasNearby && ' nearby'}
    </BodyText>
    <CSSBreakpoint max="desktop">
      {hasFiltersApplied && <TextLink onClick={onResetAllClick}>Reset filters</TextLink>}
    </CSSBreakpoint>
  </VerticalSpacer>
}

function mapStateToProps(state: App.State): MappedStateProps {
  return {
    windowSearch: state.router.location.search,
  }
}

export default connect(mapStateToProps)(HotelSearchDestinationNoResults)
